

/// <reference path="TaxAnnotation.ts" />

// Generated class TaxMenuAnnotation_ManagedObject

class TaxMenuAnnotation_ManagedObject extends TaxAnnotation
{
}
